export default {
  title: 'Allergene',
  description:
    'Bitte beachte, dass dieser {{product}} die folgenden Zutaten oder daraus gewonnene Erzeugnisse enthält:',
  options: {
    dairy: 'Milchprodukte/Milch',
    eggs: 'Eier',
    fish: 'Fisch',
    gluten: 'Gluten',
    mango: 'Mango',
    peanuts: 'Erdnüsse',
    sesame: 'Sesam',
    shellfish: 'Schalentiere',
    soy: 'Soja',
    tree_nuts: 'Baumnüsse',
    celery: 'Sellerie',
    crustaceans: 'Krebstiere',
    lupin: 'Lupine',
    molluscs: 'Weichtiere',
    mustard: 'Senf',
    nuts: 'Nüsse',
    sulphites: 'Sulfite',
    almonds: 'Mandeln',
    barley: 'Gerste',
    brazil_nuts: 'Paranüsse',
    cashew: 'Cashewnüsse',
    hazelnuts: 'Haselnüsse',
    kamut: 'Kamut',
    macadamia: 'Macadamianüsse',
    oats: 'Hafer',
    pecan: 'Pekannüsse',
    pistachios: 'Pistazien',
    rye: 'Roggen',
    spelt: 'Dinkel',
    walnuts: 'Walnüsse',
    wheat: 'Weizen',
    sugared_drink: 'Gezuckerter Drink',
    lentils: 'Linsen',
    queensland_nuts: 'Queensland-Nüsse',
  },
};
